export type Testimonial = {
  id: string;
  rating: number; // 1-5
  quote: string;
  author: string;
  detail?: string;
  date: string; // ISO
};

// Brand-level testimonials. Real reviews are added here as they come in.
// Highest-rated are surfaced in the homepage live banner.
export const TESTIMONIALS: Testimonial[] = [
  {
    id: "t-001",
    rating: 5,
    quote:
      "The certification, the packaging, the conversation, everything felt considered. The stone arrived exactly as described.",
    author: "Eleanor M.",
    detail: "1.62ct Round Brilliant",
    date: "2026-03-14",
  },
  {
    id: "t-002",
    rating: 5,
    quote:
      "Genuine concierge service. They sourced a step-cut to my exact spec and walked me through the IGI report.",
    author: "James R.",
    detail: "Bespoke Emerald cut",
    date: "2026-02-02",
  },
  {
    id: "t-003",
    rating: 5,
    quote:
      "Quiet, precise, and unhurried. I never felt sold to. The stone is extraordinary in person.",
    author: "Priya S.",
    detail: "2.04ct Oval",
    date: "2026-01-19",
  },
  {
    id: "t-004",
    rating: 5,
    quote:
      "Insured shipping, signed delivery, the whole thing handled with care. My local jeweller confirmed the grading immediately.",
    author: "Marcus L.",
    detail: "Loose stone, set locally",
    date: "2025-12-08",
  },
  {
    id: "t-005",
    rating: 4,
    quote:
      "Took a moment to choose between three stones, they sent comparison photos under multiple lighting conditions without being asked.",
    author: "Hana K.",
    detail: "1.08ct Pear",
    date: "2025-11-22",
  },
];

export function getTopTestimonials(limit = 5): Testimonial[] {
  return [...TESTIMONIALS]
    .sort((a, b) => b.rating - a.rating || (a.date < b.date ? 1 : -1))
    .slice(0, limit);
}
